import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";

import MainLayout from "../../../../components/layout/MainLayout";
import Breadcrumbs from "../../../../components/common/Breadcrumbs";
import ViolenceRiskForm from "./ViolenceRiskForm";

import { createViolenceRisk } from "../../../../store/slices/violenceRisksSlice";
import { fetchPatient } from "../../../../store/slices/patientsSlice";

const AddViolenceRisk = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { state } = useLocation();

    const { caseId, patientId } = state || {};

    const [formData, setFormData] = useState({
        caseId: caseId || null,
        patientId: patientId || null,
        assessmentTiming: "",
        patientName: "",
        date: "",
        violentThreats: "",
        violentActs: "",
        substanceMisuse: "",
        psychoticSymptoms: "",
        personalityDisorder: "",
        nonCompliance: "",
        suspicion: "",
        lackEmpathy: "",
        unrealisticPlanning: "",
        futureStress: "",
        overallRisk: "",
        suggestedAction: "",
        justification: "",
    });

    useEffect(() => {
        if (patientId) {
            dispatch(fetchPatient(patientId))
                .unwrap()
                .then((patient) => {
                    if (patient) {
                        setFormData((prev) => ({
                            ...prev,
                            patientName: `${patient.first_name || ""} ${patient.last_name || ""}`.trim(),
                        }));
                    }
                })
                .catch((err) => console.error("Failed to prefill patient name for LAMA:", err));
        }
    }, [dispatch, patientId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // 🔁 camelCase → snake_case mapping
    const toSnakeCasePayload = (data) => ({
        case_id: data.caseId,
        patient_id: data.patientId,
        assessment_timing: data.assessmentTiming,
        patient_name: data.patientName,
        date: data.date,

        violent_threats: data.violentThreats,
        violent_acts: data.violentActs,
        substance_misuse: data.substanceMisuse,
        psychotic_symptoms: data.psychoticSymptoms,
        personality_disorder: data.personalityDisorder,
        non_compliance: data.nonCompliance,
        suspicion: data.suspicion,
        lack_empathy: data.lackEmpathy,
        unrealistic_planning: data.unrealisticPlanning,
        future_stress: data.futureStress,

        overall_risk: data.overallRisk,
        suggested_action: data.suggestedAction,
        justification: data.justification,
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const payload = toSnakeCasePayload(formData);

            const res = await dispatch(createViolenceRisk(payload)).unwrap();

            Swal.fire({
                title: "Saved!",
                text: "V-RISK-10 Assessment completed.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false,
            });

            navigate(`/residential/optional/violence-risk/edit/${res.id || res.data?.id || (res && res[0]?.id)}`, { state: { patientId: patientId || (res && res.patient_id), caseId: caseId || (res && res.case_id) } });
        } catch (error) {
            Swal.fire({
                title: "Error",
                text: "Failed to save V-RISK-10 assessment.",
                icon: "error",
            });
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                <div className="card">
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <ViolenceRiskForm
                                formData={formData}
                                handleChange={handleChange}
                            />

                            <div className="col-12 d-flex justify-content-end mt-3">
                                <button
                                    type="submit"
                                    className="btn btn-primary px-4"
                                >
                                    <i className="ri-save-2-line me-1"></i>
                                    Save
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default AddViolenceRisk;
